<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="data-card-main grid-layout">
            <div v-for="(obj, index) in computedInputsTypeElements" :key="index" :class="getClassesByTheElement(obj)">
              <label>{{ obj.label }}:</label>
              {{ formatedValue(model[obj.name], obj) }}
            </div>
          </q-card-section>

          <div v-if="compositions.length" class="col-12">
            <q-card class="no-shadow bg-transparent">
              <q-tabs
                id="jt-compositions"
                v-model="tab"
                align="start"
                color="dark"
                dense
                active-color="primary"
                indicator-color="primary"
              >
                <q-tab
                  v-for="(composition, index) in compositions"
                  :key="index"
                  :name="composition.model"
                  :label="(composition.title || composition.label) + (composition.required ? ' *' : '')"
                  :icon="composition.icon"
                  :default="index === 0"
                />
              </q-tabs>
              <q-separator />
              <q-tab-panels v-model="tab" animated>
                <q-tab-panel :name="compositions[0].model" keep-alive>
                  <jt-composition
                    :ref="`composition-${index}`"
                    :id="compositions[0].model"
                    :columns="compositions[0].columns"
                    :buttons="compositions[0].buttons"
                    :data="compositions[0].data"
                    :required="compositions[0].required"
                    :allowCustomEditModal="compositions[0].allowCustomEditModal"
                    :dependenciasObrigatoria="compositions[0].dependenciasObrigatoria"
                    :dependenciasNaoObrigatoria="compositions[0].dependenciasNaoObrigatoria"
                    :modelForm="compositions[0].modelForm"
                    @action-click="button => actionButtonComposition(button)"
                    @composition-modal-close="(f) => $emit('composition-modal-close', f)"
                  />
                </q-tab-panel>
                <q-tab-panel :name="compositions[1].model" >
                  <jt-composition
                    multiselect
                    :ref="`composition-${index}`"
                    :id="compositions[1].model"
                    :columns="compositions[1].columns"
                    :buttons="compositions[1].buttons"
                    :data="compositions[1].data"
                    :required="compositions[1].required"
                    :allowCustomEditModal="compositions[1].allowCustomEditModal"
                    :dependenciasObrigatoria="compositions[1].dependenciasObrigatoria"
                    :dependenciasNaoObrigatoria="compositions[1].dependenciasNaoObrigatoria"
                    :modelForm="compositions[1].modelForm"
                    @action-click="button => actionButtonComposition(button)"
                    @composition-modal-close="(f) => $emit('composition-modal-close', f)"
                  />
                </q-tab-panel>
              </q-tab-panels>
            </q-card>
          </div>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm, JtInput, JtComposition, JtCompositions } from 'jtech-webcomps'
const { pageDetail } = JtCrud

@Component({
  mixins: [pageDetail],
  name: 'TicketPage',
  components: { JtDynamicForm, JtInput, pageDetail, JtComposition, JtCompositions }
})
class TicketPage extends Vue {
  tab = 'mtrs'

  get compositions () {
    return (
      // eslint-disable-next-line no-undef
      _.chain(this.formateInputsArray)
        .find(ci => ci.type === 'composition')
        .get('elements')
        .filter(e => {
          if (e.renderIf) {
            return this.__getDynamicConditional(e)
          }
          return true
        })
        .map(e => {
          if (!this.elements[0].dadosForm[e.model]) {
            this.elements[0].dadosForm[e.model] = []
          }
          e.data = this.elements[0].dadosForm[e.model]
          e.modelForm = e.model
          e.uuid = 'id'
          e.columns.map(col => {
            col.name = col.name || col.model
            col.field = col.name
            col.sortable = true
            col.align = 'left'
            return col
          })
          return e
        })
        .value() ?? []
    )
  }

  actionButtonComposition (buttonParams) {
    this.$emit('action-button', buttonParams.button, buttonParams.params, buttonParams)
  }
}

export default TicketPage
</script>
<style ></style>
